import { useEffect, useState } from "react";
import { useReduxStore } from "../../hooks/useReduxStore";
import { GetPackagesAction } from "../../store/Actions/action";
import { updateHome } from "../../store/Reducers/homeReducer";
import { useNavigate } from "react-router-dom";
import { isUserSubscribed } from "../../helper/accessTypeHelper";

export default function useSubscription() {
  const { dispatch, getState } = useReduxStore();
  const { packages, packagesLoading } = getState("Home");
  const { token, userData } = getState("AUTH");
  const [billingCycle, setBillingCycle] = useState("yearly"); // "monthly" | "yearly"
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(GetPackagesAction());
  }, [dispatch]);

  const onSelectPlan = (pkg) => {
    dispatch(updateHome({ selectedPackage: pkg }));
    if (!token) {
      navigate("/Login", {
        state: { route: "/Checkout", package: pkg, isSubscription: true },
      });
    } else {
      navigate("/Checkout", {
        state: { package: pkg, isSubscription: true },
      });
    }
  };

  const isSubscribed = isUserSubscribed(userData);

  return {
    packages,
    packagesLoading,
    billingCycle,
    setBillingCycle,
    onSelectPlan,
    isSubscribed,
    userData,
  };
}
